module.exports = __webpack_public_path__ + "static/media/Sidney-Rees.9f2bf173.jpg";